// extracted by mini-css-extract-plugin
export default {"tableWrap":"TransactionTable_tableWrap__Atxfs","table":"TransactionTable_table__Zoj42","table__body":"TransactionTable_table__body__Z7WqA"};